export default __webpack_public_path__ + "static/logo-3192bd56e61618123dd9c4864b16e988.svg";